export default "__VITE_ASSET__COBAIKlS__"